// react component to request for fullscreen

import { useEffect, useState, useMemo } from "react";

export default function useRequestFullScreen() {
  const [isFullScreen, setIsFullScreen] = useState(false);

  useEffect(() => {
    const onFullScreenChange = () => {
      setIsFullScreen(document.fullscreenElement !== null);
    };

    document.addEventListener("fullscreenchange", onFullScreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", onFullScreenChange);
    };
  }, []);

  const requestFullScreen = () => {
    document.documentElement.requestFullscreen();
  };
  function setFullScreen() {
    if (document === undefined) return;
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
  }

  const exitFullScreen = () => {
    if (document.fullscreenElement) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };

  // useMemo for fullscreenenabled

  const isFullScreenAvailable = useMemo(() => {
    // document is not defined
    if (typeof document === "undefined") {
      return false;
    }
    return document.fullscreenEnabled;
  }, []);

  return {
    isFullScreen,
    requestFullScreen,
    setFullScreen,
    exitFullScreen,
    isFullScreenAvailable,
  };
}
